var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3335 0.333252H17.6668C24.2943 0.333252 29.6668 5.70584 29.6668 12.3333V17.6666C29.6668 24.294 24.2943 29.6666 17.6668 29.6666H12.3335C5.70608 29.6666 0.333496 24.294 0.333496 17.6666V12.3333C0.333496 5.70584 5.70608 0.333252 12.3335 0.333252ZM17.6668 2.99992H12.3335C7.17884 2.99992 3.00016 7.1786 3.00016 12.3333V17.6666C3.00016 22.8212 7.17884 26.9999 12.3335 26.9999H17.6668C22.8215 26.9999 27.0002 22.8212 27.0002 17.6666V12.3333C27.0002 7.1786 22.8215 2.99992 17.6668 2.99992Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1114 11.9441C9.43671 11.9441 8.88916 12.4917 8.88916 13.1663V22.333C8.88916 23.0077 9.43671 23.5551 10.1114 23.5551C10.786 23.5551 11.3336 23.0077 11.3336 22.333V13.1663C11.3336 12.4917 10.786 11.9441 10.1114 11.9441Z",
    fill: "#264042",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 13.1663H17.4445C17.0154 13.1663 16.6054 13.2445 16.2222 13.3802V13.1663C16.2222 12.4917 15.6746 11.9441 15 11.9441C14.3253 11.9441 13.7778 12.4917 13.7778 13.1663V16.833V22.333C13.7778 23.0077 14.3253 23.5551 15 23.5551C15.6746 23.5551 16.2222 23.0077 16.2222 22.333V16.833C16.2222 16.1589 16.7704 15.6107 17.4445 15.6107H18.6666C19.3408 15.6107 19.8889 16.1589 19.8889 16.833V22.333C19.8889 23.0077 20.4365 23.5551 21.1112 23.5551C21.7858 23.5551 22.3333 23.0077 22.3333 22.333V16.833C22.3333 14.8107 20.6888 13.1663 18.6666 13.1663Z",
    fill: "#264042",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1112 6.44409C9.10039 6.44409 8.27783 7.26664 8.27783 8.27742C8.27783 9.2882 9.10039 10.1108 10.1112 10.1108C11.122 10.1108 11.9445 9.2882 11.9445 8.27742C11.9445 7.26664 11.122 6.44409 10.1112 6.44409Z",
    fill: "#264042",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ab93f9cd7f22ef3c9d2aeddcf631e35f.svg";
export { ForwardRef as ReactComponent };